import { JsonRpc } from "@proton/js";

interface OutcomeRowData {
  outcome_id?: number;
  name?: string;
  display_order?: number;
}

const getOutcomeRowData = (row: any): OutcomeRowData => {
  if (row?.data && typeof row.data === "object") {
    return row.data;
  }
  return row || {};
};

export const fetchOutcomeNamesForMarket = async (
  rpc: JsonRpc,
  contractName: string,
  marketId: number,
): Promise<string[]> => {
  const outcomesResult = await rpc.get_table_rows({
    json: true,
    code: contractName,
    scope: marketId.toString(),
    table: "outcomes",
    limit: 100,
  });

  const normalizedRows = outcomesResult.rows
    .map(getOutcomeRowData)
    .filter(
      (row): row is Required<Pick<OutcomeRowData, "outcome_id" | "name">> &
        OutcomeRowData =>
        typeof row.outcome_id === "number" && typeof row.name === "string",
    )
    .sort((a, b) => a.outcome_id - b.outcome_id);

  return normalizedRows.map((row) => row.name);
};
